export default __webpack_public_path__ + "static/media/image7tum.bf029d46.jpg";